interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "CDF";
};

const CDF: Currency = Object.freeze({
  "displayName": "Congolese Franc",
  "numericCode": 976,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "CDF",
  "symbol": "Fr"
});

export { CDF };
